import { Route } from "react-router-dom";
import AffiliateDashboardScreen from "../../../container/Affiliate/AffiliateDashboardScreen";
import { APP_URLS } from "../../../utils/constant";

const AffiliateDashboardRoutes = (access = {}) => {
  const { view = false } = access || {};
  const screenPermissions = { view };

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.AFFILIATE.DASHBOARD}
          element={<AffiliateDashboardScreen screenPermissions={screenPermissions} />}
        />
      )}
    </>
  );
};

export default AffiliateDashboardRoutes;
